 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLHALF from '@/components/xhtml/half'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTMLCOPY from '@/components/xhtml/copy'
 import XHTMLDED from '@/components/xhtml/ded'
 import XHTMLCONTENTS from '@/components/xhtml/contents'
 import XHTMLPREFACE from '@/components/xhtml/preface'
 import XHTMLINTRO from '@/components/xhtml/intro'
 import XHTMLPART1 from '@/components/xhtml/part1'
 import XHTMLCH1 from '@/components/xhtml/ch1'
 import XHTMLCH2 from '@/components/xhtml/ch2'
 import XHTMLCH3 from '@/components/xhtml/ch3'
 import XHTMLCH4 from '@/components/xhtml/ch4'
 import XHTMLPART2 from '@/components/xhtml/part2'
 import XHTMLCH5 from '@/components/xhtml/ch5'
 import XHTMLCH6 from '@/components/xhtml/ch6'
 import XHTMLCH7 from '@/components/xhtml/ch7'
 import XHTMLPART3 from '@/components/xhtml/part3'
 import XHTMLCH8 from '@/components/xhtml/ch8'
 import XHTMLCH9 from '@/components/xhtml/ch9'
 import XHTMLCH10 from '@/components/xhtml/ch10'
 import XHTMLPART4 from '@/components/xhtml/part4'
 import XHTMLCH11 from '@/components/xhtml/ch11'
 import XHTMLCH12 from '@/components/xhtml/ch12'
 import XHTMLCH13 from '@/components/xhtml/ch13'
 import XHTMLCONCL from '@/components/xhtml/concl'
 import XHTMLREF from '@/components/xhtml/ref'
 import XHTMLACK from '@/components/xhtml/ack'
 import XHTMLINDEX from '@/components/xhtml/index'
 import XHTMLAUTHOR from '@/components/xhtml/author'
 import XHTMLBACK1 from '@/components/xhtml/back1'
 import XHTMLBACK2 from '@/components/xhtml/back2'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/contents",
 			"name" : "xhtml/contents",
 			"component" : XHTMLCONTENTS
 		},
 		{
 			"path" : "/xhtml/preface",
 			"name" : "xhtml/preface",
 			"component" : XHTMLPREFACE
 		},
 		{
 			"path" : "/xhtml/intro",
 			"name" : "xhtml/intro",
 			"component" : XHTMLINTRO
 		},
 		{
 			"path" : "/xhtml/part1",
 			"name" : "xhtml/part1",
 			"component" : XHTMLPART1
 		},
 		{
 			"path" : "/xhtml/ch1",
 			"name" : "xhtml/ch1",
 			"component" : XHTMLCH1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js